/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Reply_NoteInputs */

const en_contact_form_reply_note = /** @type {(inputs: Contact_Form_Reply_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We reply to the email above. Nothing else is done with it.`)
};

const pl_contact_form_reply_note = /** @type {(inputs: Contact_Form_Reply_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiemy na podany e-mail. Nie używamy go do niczego innego.`)
};

/**
* | output |
* | --- |
* | "We reply to the email above. Nothing else is done with it." |
*
* @param {Contact_Form_Reply_NoteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_reply_note = /** @type {((inputs?: Contact_Form_Reply_NoteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Reply_NoteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_reply_note(inputs)
	return en_contact_form_reply_note(inputs)
});